module.exports = __webpack_public_path__ + "static/media/DiceGame.0db2d6d8.png";